<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Refunds Management</h2>
      <p class="text-sm text-gray-500 mt-1">Review and manage refund requests from users.</p>
    </div>
    <button
      (click)="loadRefunds()"
      class="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition">
      Refresh
    </button>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadRefunds()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <!-- Data Grid -->
  <div *ngIf="!isLoading && !errorMessage" class="bg-white rounded-2xl shadow overflow-hidden">
    <table class="w-full text-sm">
      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-4">Refund ID</th>
          <th>Booking ID</th>
          <th>Requested By</th>
          <th>Amount</th>
          <th>Reason</th>
          <th>Created At</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let refund of refunds" class="border-t hover:bg-gray-50">
          <td class="p-4 font-medium text-gray-800">#{{ refund.id }}</td>
          <td class="text-blue-600 hover:underline cursor-pointer">#{{ refund.booking_id }}</td>
          <td class="text-gray-600">User #{{ refund.requested_by }}</td>
          <td class="font-semibold text-gray-800">${{ refund.amount | number:'1.2-2' }}</td>
          <td class="text-gray-500 max-w-xs truncate" title="{{ refund.reason }}">{{ refund.reason }}</td>
          <td class="text-gray-600">{{ refund.created_at | date:'mediumDate' }}</td>
          <td>
            <span [ngClass]="getBadgeColorClass(refund.status)" class="px-2 py-1 rounded-full text-xs font-medium capitalize border">
              {{ refund.status }}
            </span>
          </td>
          <td>
             <div class="flex items-center gap-2 pr-4">
                <select 
                    [ngModel]="refund.status" 
                    (ngModelChange)="updateStatus(refund, $event)"
                    [disabled]="updatingRefundId === refund.id"
                    class="w-full border border-gray-300 rounded-lg px-2 py-1 text-xs outline-none focus:ring-2 focus:ring-blue-500 bg-white">
                   <option value="pending">Pending</option>
                   <option value="approved">Approved</option>
                   <option value="rejected">Rejected</option>
                </select>
                <div *ngIf="updatingRefundId === refund.id" class="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
             </div>
          </td>
        </tr>
        <tr *ngIf="refunds.length === 0">
          <td colspan="8" class="p-8 text-center text-gray-500">No refund requests found.</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
